const branches = {
  branches: {
    pageHeader: '支店',
    addBranchOffice: '+ 支店の追加',
    name: '名称',
    city: '市区町村',
    state: '都道府県',
    country: '国',
    branches: '支部',
    noBranchAvailable: '** 使用可能な支店はありません **'
  }
};

export default branches;
